import React from 'react';

import {FormControl } from '@material-ui/core';
import {KeyboardDatePicker, KeyboardDateTimePicker, KeyboardTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

export const MUIDateWidget = ({
  id,
  name,
  required,
  readonly,
  disabled,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  schema,
}) => {
  const format = schema.dateFormat || 'YYYY-MM-DD';  // TODO: take from schema
  const _onChange = (value) => onChange(value && value.format(format));
  const _onBlur = ({ target: { value } }) =>
    onBlur(id, value);
  const _onFocus = ({
    target: { value },
  }) => onFocus(id, value);

  return (
    <FormControl
      fullWidth={true}
      required={required}
    >
      <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        id={id}
        label={label || schema.title}
        autoFocus={autofocus}
        required={required}
        disabled={disabled || readonly}
        name={name}
        format={format}
        value={value || null}
        onChange={_onChange}
        onBlur={_onBlur}
        onFocus={_onFocus}
      />
      </MuiPickersUtilsProvider>
    </FormControl>
    
  );
};

export const MUIDateTimeWidget = ({
  id,
  name,
  required,
  readonly,
  disabled,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  schema,
}) => {
  const format = schema.dateFormat || 'YYYY-MM-DD HH:mm';  // TODO: take from schema
  const _onChange = (value) => onChange(value && value.format(format));
  const _onBlur = ({ target: { value } }) =>
    onBlur(id, value);
  const _onFocus = ({
    target: { value },
  }) => onFocus(id, value);

  return (
    <FormControl
      fullWidth={true}
      required={required}
    >
      <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDateTimePicker
        id={id}
        label={label || schema.title}
        autoFocus={autofocus}
        ampm={false}
        required={required}
        disabled={disabled || readonly}
        name={name}
        format={format}
        value={value || null}
        onChange={_onChange}
        onBlur={_onBlur}
        onFocus={_onFocus}
      />
      </MuiPickersUtilsProvider>
    </FormControl>
    
  );
};

export const MUITimeWidget = ({
  id,
  name,
  required,
  readonly,
  disabled,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  schema,
}) => {
  const format = schema.dateFormat || 'HH:mm';  // TODO: take from schema
  const _onChange = (value) => onChange(value && value.format(format));
  const _onBlur = ({ target: { value } }) =>
    onBlur(id, value);
  const _onFocus = ({
    target: { value },
  }) => onFocus(id, value);

  return (
    <FormControl
      fullWidth={true}
      required={required}
    >
      <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardTimePicker
        id={id}
        label={label || schema.title}
        autoFocus={autofocus}
        ampm={false}
        required={required}
        disabled={disabled || readonly}
        name={name}
        format={format}
        value={value || null}
        onChange={_onChange}
        onBlur={_onBlur}
        onFocus={_onFocus}
      />
      </MuiPickersUtilsProvider>
    </FormControl>
    
  );
};
